import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Card, Form, Button, Input, message, Select } from 'antd'
import { connect } from 'react-redux'

import { getNowAcademicYear } from '../../utils/dateUtil'
import storageUtils from '../../utils/storageUtils'
import { req_add_eps_blogger } from '../../api'
const { Option } = Select;
const Item = Form.Item

class ManageBloggerEditModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////  
    static propTypes = {
        blogger: PropTypes.object
    }

    state = {
        isUpdate: false,
        isInsert: false,
        item: {
            BloggerCode: '',
            BloggerName: '',
            BlogType: 'STUDENT',
            BloggerStartYear: getNowAcademicYear(new Date())
        }
    }

    constructor(props) {
        super(props)

        this.get_files = React.createRef()
        this.editor = React.createRef()
    }

    UNSAFE_componentWillMount() {
        this.init()
    }

    componentDidMount() {

    }

    // 遠端數據處理 //////////////////////////////////////////////


    api_modify_item = async (item) => {
        const result = await req_add_eps_blogger(item, storageUtils.getUser().token)
        if (result.status === "success") {
            message.success(result.message)
        } else {
            message.error(result.message)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init = () => {
        // console.log(this.props.bulletinboard)
        if (this.props.bulletinboard) {
            const item = this.props.bulletinboard
            this.setState({ item })
        }
    }

    // 操作互動處理 //////////////////////////////////////////////

    onFinish = (values) => {
        const { BloggerCode, BloggerName,  BloggerStartYear } = values
        const obj = {
            BloggerCode: BloggerCode,
            BloggerName: BloggerName,
            BlogType: this.state.item.BlogType,
            BloggerStartYear: BloggerStartYear
        }
       // console.log(obj)
        this.api_modify_item(obj)
    }


    handleChange = (values) => {
       // console.log(values)
        const { item } = this.state
        Object.keys(item).forEach(propertyName => {
            if (propertyName === 'BlogType') {
                item[propertyName] = values
            }

        });
        this.setState({ item })
    }



    /////////////////////////////////////////////////////////// 

    render() {
        const { BlogType, BloggerCode, BloggerName, BloggerStartYear } = this.state.item
        return (
            <Card>
                <Form
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Item
                        label="職(學)號"
                        name="BloggerCode"
                        initialValue={BloggerCode}
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫職(學)號' },
                        ]}
                    >
                        <Input placeholder="輸入職(學)號" />
                    </Item>
                    <Item
                        label="姓名"
                        name="BloggerName"
                        initialValue={BloggerName}
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫姓名' },
                        ]}
                    >
                        <Input placeholder="輸入姓名" />
                    </Item>
                    <Item
                        label="入校民國年"
                        name="BloggerStartYear"
                        initialValue={BloggerStartYear}
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫入校民國年' },
                        ]}
                    >
                        <Input placeholder="000" />
                    </Item>
                    <Item label="分類">
                        <Select defaultValue={BlogType} onChange={this.handleChange}  style={{ width: '100%' }}>
                            <Option value="STUDENT">學生</Option>
                            <Option value="TEACHER">教職員</Option>
                        </Select>
                    </Item>
                    <Item>
                        <Button type='primary' htmlType="submit" block>{'送出'}</Button>
                    </Item>
                </Form>
            </Card>
        )
    }
}


export default connect(
    state => ({ user: state.user }),
    {}
)(ManageBloggerEditModal)